import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  MixedWidget2,
  MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  TablesWidget13,
  MixedWidget8,
  StatisticsWidget5,
  MixedWidget1,
} from '../../../_metronic/partials/widgets'
import { CustomerTable } from '../Customer/CustomerTable'
import CustomerCount from '../Customer/CustomerCount'
import ShipmentCount from '../Shipment/ShipmentCount'
import { OutStanding } from './OutStanding'
import { TotalBookingShipment } from './TotalBookingShipment'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SummaryCard from './SummaryCard'
import { ShipmentDash } from './ShipmentDash'





const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8 mt-0'>
      <div className='col-xl-4'>
        {/* <MixedWidget2
          className='card-xl-stretch mb-5 mb-xl-8'
           chartColor='#FFC5C9'
          chartHeight='200px'
          strokeColor='#fff'
        /> */}
        <CustomerCount />
      </div>
      <div className='col-xl-4'>
        <div className='row' style={{ rowGap: '20px' }}>
          <div className='col-md-12'>
            {/* <MixedWidget10
              className='card-xl-stretch mb-xl-8'
              chartColor='danger'
              chartHeight='150px'
            /> */}
            {/* <ShipmentCount /> */}
            <OutStanding />
          </div>
        </div>
        <div className='row align-items-stretch'>
          <div className='col-md-12 d-flex' style={{height: '100%'}}>
            <SummaryCard />
          </div>
        </div>
      </div>
      <div className='col-xl-4'>
        {/* <MixedWidget2
          className='card-xl-stretch mb-5 mb-xl-8'
           chartColor='#FFC5C9'
          chartHeight='200px'
          strokeColor='#fff'
        /> */}
        {/* <MixedWidget1 className='card-xl-stretch mb-xl-8' /> */}
        <ShipmentDash className='card-xl-stretch mb-xl-8' />
      </div>
      {/* <div className='col-xxl-4'>
        <ListsWidget5 className='card-xxl-stretch' />
      </div> */}
      {/* <div className='col-12'>
        
        <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        <MixedWidget11
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='175px'
        /> 
        <CustomerTable className='card-xxl-stretch mb-5 mb-xl-8' />
      </div> */}
      {/* <div className='col-xl-8'>
        <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div> */}
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    {/* <div className='row gy-5 gx-xl-8'>
      <div className='col-xxl-4'>
        <ListsWidget3 className='card-xxl-stretch mb-xl-3' />
      </div>
      <div className='col-xl-8'>
        <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div>
    </div> */}
    {/* end::Row */}

    {/* begin::Row */}
    {/* <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <ListsWidget2 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
      </div>
    </div> */}
    {/* end::Row */}

    {/* <div className='row g-5 gx-xxl-8'>
      <div className='col-xxl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div>
      <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div>
    </div> */}
    <ToastContainer />

  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }